import React, { useRef } from 'react'
import { useTable, usePagination, useGlobalFilter } from "react-table"

function TableAulasGrupo({ columns, data, length = true, search = true, titulo = '', globalFilter: externalGlobalFilter, pageSize: externalPageSize, setPageSize: setExternalPageSize }) {

    const props = useTable(
        {
            columns,
            data,
            initialState: { pageSize: 20 }

        },
        useGlobalFilter,
        usePagination,

    );
    const {
        getTableBodyProps,
        rows,
        prepareRow,
        setGlobalFilter,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        nextPage,
        previousPage,
        setPageSize: setInternalPageSize,
        state: { pageIndex, pageSize: internalPageSize, globalFilter: internalGlobalFilter }
    } = props;

    // Sincronizar globalFilter externo com interno
    React.useEffect(() => {
        if (externalGlobalFilter !== undefined && externalGlobalFilter !== internalGlobalFilter) {
            setGlobalFilter(externalGlobalFilter || '');
        }
    }, [externalGlobalFilter, internalGlobalFilter, setGlobalFilter]);

    // Sincronizar pageSize externo com interno (usando useRef para evitar loops)
    const prevExternalPageSize = useRef(externalPageSize);
    React.useEffect(() => {
        if (externalPageSize !== undefined && externalPageSize !== prevExternalPageSize.current) {
            setInternalPageSize(externalPageSize);
            prevExternalPageSize.current = externalPageSize;
        }
    }, [externalPageSize, setInternalPageSize]);

    const pageSize = externalPageSize !== undefined ? externalPageSize : internalPageSize;

    return (
        <>
            <div className="table-full-width mt-3 mb-3">
                <div className="table-responsive">
                    <table className="table align-middle mt-1 table-striped table-hover">
                        <thead>
                            <tr>
                                <th colSpan="5" className='bg-primary text-white rounded-top'>{titulo}</th>
                            </tr>
                        </thead>
                        <thead>
                            <tr className='border border-white text-nowrap'>
                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted'>#</th>
                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted'>Nome da Aula</th>
                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted'>Gestor</th>
                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted'>Data</th>
                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted'>Ações</th>
                            </tr>
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, i) => {
                                prepareRow(row);
                                return (
                                    <tr className='text-nowrap' {...row.getRowProps()}>
                                        {row.cells.map(cell => {
                                            return (
                                                <td {...cell.getCellProps()}>
                                                    {cell.render("Cell")}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}

                        </tbody>
                        <tfoot>
                            <tr>
                                <th colSpan="7" className='bg-primary text-white rounded-bottom'>
                                    <div className="table-footer d-flex justify-content-between align-items-center">
                                        <span>Exibindo {pageSize < rows.length ? pageSize : rows.length} de {rows.length} registros</span>
                                        <div>
                                            <span>Página {pageIndex + 1} de {pageOptions.length}</span>
                                            <button className="btn btn-primary btn-sm ms-2 text-white" onClick={() => previousPage()} disabled={!canPreviousPage}>
                                                <i className="bi bi-caret-left"></i>
                                            </button>
                                            <button className="btn btn-primary btn-sm ms-1 text-white" onClick={() => nextPage()} disabled={!canNextPage}>
                                                <i className="bi bi-caret-right"></i>
                                            </button>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </>
    )

}
export default TableAulasGrupo;